// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3z-0";
export var eligibilityCardNotEligible = "_3z-1";